import Cookies from 'cookie-universal'
import { defineNuxtPlugin, useRequestEvent } from '#app'

export default defineNuxtPlugin((nuxtApp) => {
  if (import.meta.server) {
    const event = useRequestEvent()
    if (!event?.node) {
      return
    }
    const { req, res } = event.node
    nuxtApp.provide('cookies', () => Cookies(req, res, false))
  } else {
    nuxtApp.provide('cookies', () => Cookies())
  }
})
